"use client";

import { BUSINESS_TYPES } from "@/features/quote/shared/quote-config";
import { ChoiceCard } from "@/features/quote/ui/ChoiceCard";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";

export function BusinessStep() {
  const { autoAdvance, next, back, canGoBack, canAdvance } = useWizard();
  const [{ business }, answer] = useStep("business");

  return (
    <section>
      <StepHeading
        title="Hvilken type virksomhed?"
        body="Vælg den type lokale I har - så matcher vi med firmaer der har erfaring med netop det."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        {BUSINESS_TYPES.map((b) => (
          <ChoiceCard
            key={b.value}
            selected={business === b.value}
            onClick={() => {
              answer({ business: b.value });
              autoAdvance();
            }}
            icon={b.icon}
            title={b.label}
            compact
          />
        ))}
      </div>
      <StepNav
        onBack={canGoBack ? back : undefined}
        onNext={next}
        nextEnabled={canAdvance}
        nextLabel="Næste →"
      />
    </section>
  );
}
